import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "formulario" }
const _hoisted_2 = { class: "container mx-auto max-w-4xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl" }
const _hoisted_3 = { class: "font-bold text-center text-2xl" }
const _hoisted_4 = { class: "font-bold text-center text-xl mt-2" }
const _hoisted_5 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_6 = { class: "w-full px-2" }
const _hoisted_7 = { class: "block mb-1" }
const _hoisted_8 = { class: "text-sm text-red-500 p-error" }
const _hoisted_9 = { class: "flex flex-wrap py-2 mt-3 w-full" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_12 = { class: "pi pi-arrow-circle-down mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700 mx-5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('titulo.credenciales')), 1),
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('label.complete.credencial')), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('label.ingrese.documento')), 1),
                _createVNode(_component_Field, {
                  name: "documento",
                  modelValue: _ctx.formData.documento,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.documento) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: _ctx.$t('label.documento'),
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_ErrorMessage, { name: "documento" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "submit",
                class: "mt-4 w-full md:w-auto px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_11, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_12, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _createTextVNode(_toDisplayString(_ctx.$t('boton.descargar.credencial')), 1)
              ], 8, _hoisted_10)
            ])
          ]),
          _createVNode(_component_BlockUI, {
            blocked: _ctx.isSubmitting,
            fullScreen: ""
          }, null, 8, ["blocked"])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ], 64))
}